import { Application } from '@hotwired/stimulus';
import '../helpers/numberWithDelimiter';

const application = Application.start();

// Configure Stimulus development experience
application.debug = false;
window.Stimulus = application;

export { application };
